import { CLEAR_ERRORS, SET_NO_AUTH_REDIRECT_FROM_URL } from "../types";

export const clearErrors = () => dispatch => dispatch({ type: CLEAR_ERRORS });

export const setNoAuthRedirectFromUrl = url => dispatch => dispatch({ type: SET_NO_AUTH_REDIRECT_FROM_URL, payload: url });
